module.exports = __webpack_public_path__ + "static/media/send.a0228735.svg";